import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { MasterCustomerService} from '../../services/master-customer.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import { AuthService} from '../../../../auth/auth.service';
import {fiveDecCompanies} from '../../../../../environments/environment';

@Component({
    selector: 'app-quick-order-edit',
    templateUrl: './quick-order-edit.component.html',
    styleUrls: ['../quick-order.component.scss'],
    providers: [ AuthService ]
})
export class QuickOrderEditComponent implements OnInit {
    public savedData: {[key: string]: any} = {};
    public invalidScan = false;
    public record:
        {
            CU0_MODIFIED_ON: null;
            CU0_NAME: null;
            CU0_ID: number;
            CU0_SHORT_CODE: null;
            CU0_CREATED_BY: null;
            CU0_ALLOW_INVENTORY_MANAGEMENT: number;
            CU0_TYPE: number;
            CU0_ALLOW_DUPLICATE_BARCODES: number;
            CU0_LOGO_FILEPATH: null;
            CU0_ENABLE_ORDER_ENTRY_USAGE_DATA_SYNCHRONIZATION: number;
            CU0_MODIFIED_BY: null;
            CU0_CREATED_ON: null;
            CU0_DELETE_FLAG: number
        };
    public errors: any;
    public action: any;
    public loading: false;
    public isWorkspaceSelected: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private route: ActivatedRoute,
        private dialogRef: MatDialogRef<QuickOrderEditComponent>,
        private masterCustomerService: MasterCustomerService,
        private location: Location,
        private toastr: ToastrService,
        private router: Router,
        private authService: AuthService
    ) {
        this.savedData = {
            ID: this.data.scan.ID,
            CONTRACT_BIN_ID: this.data.scan.CONTRACT_BIN_ID,
            ITEM_ID: this.data.scan.ITEM_ID,
            RA1_SHIP_TO_NAME: this.data.scan.RA1_SHIP_TO_NAME,
            CU1_NAME: this.data.scan.CU1_NAME,
            CO1_ID: this.data.scan.CO1_ID,
            CO1_NAME: this.data.scan.CO1_NAME,
            PO_NUMBER: this.data.scan.PO_NUMBER,
            JOB_NUMBER: this.data.scan.JOB_NUMBER,
            QUANTITY: Number(this.data.scan.QUANTITY),
            MD1_PRICE: Number(this.data.scan.MD1_PRICE),
            MD1_UM: this.data.scan.MD1_UM,
            MD1_UM_SIZE: Number(this.data.scan.MD1_UM_SIZE),
            MD1_REORDER_QTY: Number(this.data.scan.MD1_REORDER_QTY),
            MD1_MIN_QTY: Number(this.data.scan.MD1_MIN_QTY),
            TOTAL_PRICE: Number(this.data.scan.TOTAL_PRICE)
        };
        this.invalidScan = this.data.invalidScan;
        this.computeTotalValue();
    }

    ngOnInit() {
        this.isWorkspaceSelected = this.getSelectedWorkspace();
        this.errors = [];
        this.record = this.masterCustomerService.initialize();

        if (this.isWorkspaceSelected) {
            this.masterCustomerService.getById( this.authService.workspaceMasterCustomerID ).subscribe(masterCustomerResult => {
                if (masterCustomerResult.success) {
                    this.record = masterCustomerResult.data;
                } else {
                    this.toastr.error('Unable to load data. Please try later!', 'Error');
                    setTimeout(() => {
                        this.loading = false;
                    }, 2000);
                    this.loading = false;
                }
            }, () => {
                this.toastr.error('Request timed out', 'Service Error');
                setTimeout(() => {
                    this.loading = false;
                }, 2000);
                this.loading = false;
            });
        }
    }

    increaseQty() {
        this.savedData.QUANTITY += Number(this.savedData.MD1_REORDER_QTY);
        this.computeTotalValue(this.record.CU0_TYPE);
    }

    decreaseQty() {
        this.savedData.QUANTITY -= Number(this.savedData.MD1_REORDER_QTY);
        if (this.savedData.QUANTITY < Number(this.savedData.MD1_MIN_QTY)) {
            this.savedData.QUANTITY = Number(this.savedData.MD1_MIN_QTY);
        }
        this.computeTotalValue();
    }

    computeTotalValue(CU0_TYPE = 1) {
        if (CU0_TYPE === 1) {
            if (Number(this.savedData.MD1_UM_SIZE) === 0) {
                this.savedData.TOTAL_PRICE = Number(this.savedData.MD1_PRICE) * Number(this.savedData.QUANTITY);
            } else {
                this.savedData.TOTAL_PRICE = (Number(this.savedData.MD1_PRICE) / Number(this.savedData.MD1_UM_SIZE))
                    * Number(this.savedData.QUANTITY);
            }
        } else {
            this.savedData.TOTAL_PRICE = Number(this.savedData.MD1_PRICE) * Number(this.savedData.QUANTITY);
        }
    }

    closeDialog(returnOutput = false) {
        this.dialogRef.close(returnOutput ? this.savedData : null);
    }

    save() {
        this.closeDialog(true);
    }

    getSelectedWorkspace() {
        return this.authService.workspaceMasterCustomerID !== null;
    }

    protected readonly fiveDecCompanies = fiveDecCompanies;
    protected readonly parseInt = parseInt;
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/quick-order/quick-order-edit/quick-order-edit.component.ts